import { createContext } from "react";

const UserContex = createContext()

export default UserContex; 

